<template>
	<div class="w-full h-full">

		<div v-if="!isMobile" class="w-full h-full relative bg-whiteSmoke overflow-hidden">
			<div class="oper-box" :style="{ color: mapTypeActive === '矢量图' ? '#333' : '#FFF' }">

				<div class="flex">
					<el-switch v-model="traceMode" style="margin-top: 2px;" @change="changeFreeMode" />
					<div class="margin-left-sm">[{{traceMode ? '足迹探索' : '自由探索'}}]</div>
				</div>

				<div class="flex">
					<el-switch v-model="viewMode" style="margin-top: 2px;" />
					<div class="margin-left-sm">[{{viewMode ? '导览' : '简洁'}}模式]</div>
				</div>

				<div class="flex flex-col flex-center">
					<el-divider direction="vertical"></el-divider>
				</div>

				<el-popover placement="top" trigger="click">
					<div class="flex flex-center gap10">
						<div class="relative flex cursor-pointer maptype"
							:class="[item.name === mapTypeActive ? 'maptype-active' : '']"
							style="width: 68px;height: 63px;" 
							v-for="(item, index) in mapType" :key="index"
							@click="changeMapType(item)">
							<img :src="item.cover" />
							<div class="absolute bottom-0 left-0 text-white width-all type-name">
								<div class="text-center font-xs padding-tb-xs">{{ item.name }}</div>
							</div>
						</div>
					</div>
					<div slot="reference" class="cursor-pointer type-label">图层类型</div>
				</el-popover>

				<el-popover placement="top" trigger="click">
					<el-radio-group v-model="themeActive" size="small" 
						:fill="themeActive === '晴空蓝' ? '#409EFF' : themeActive === '松烟绿' ? '#67C23A' : '#F56C6C'">
						<el-radio-button :label="item" 
							v-for="(item, index) in themeOptions" :key="index" />
					</el-radio-group>
					<div slot="reference" class="cursor-pointer type-label">标记主题</div>
				</el-popover>

				<div class="flex flex-col flex-center">
					<el-divider direction="vertical"></el-divider>
				</div>

				<el-dropdown trigger="click" placement="top" :tabindex="9249" 
					v-if="yearOptions && yearOptions.length" @command="checkYear">
					<div class="cursor-pointer type-label text-center" 
						style="min-width: 65px;" :style="{ color: mapTypeActive === '矢量图' ? '#333' : '#FFF' }">
						{{ yearOptions[yearActiveIndex].dicLabel }}
					</div>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item :command="yItem.dicValue"
							v-for="yItem in yearOptions" :key="yItem.dicValue">
							{{ yItem.dicLabel }}
						</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>

				<el-dropdown trigger="click" placement="top" :tabindex="9249" 
					v-if="cityOpitons && cityOpitons.length" @command="checkCity">
					<div class="cursor-pointer type-label text-center" 
						style="min-width: 35px;" :style="{ color: mapTypeActive === '矢量图' ? '#333' : '#FFF' }">
						{{ cityActiveObj.label }}
					</div>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item :command="cItem.value" v-for="cItem in cityOpitons" :key="cItem.value">
							{{ cItem.label }}
						</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>

				<el-tooltip class="item" effect="light" content="主页(初始化)" placement="bottom-start">
					<div class="reset-icon" :style="{color: mapTypeActive === '矢量图' ? '#1D9EFF' : '#FFF' }"
						@click="reset">
						<i class="icon-admin icon-admin-zhuye"></i>
					</div>
				</el-tooltip>
			</div>

			<MapViewer ref="mapEditor" :search="!traceMode" :markers="markers" :map-type="mapTypeActive" :markerMode="viewMode" :markerTheme="themeActive"
				@check="checkItem" />

			<div class="list-box" :style="{ left: foldState ? '10px' : '-314px' }">
				<ListCard :list="listData" :listType="listType" 
					@change="changeListType" @check="checkListItem" />
				<div class="fold_btn" @click="changeFoldState">
					<div v-if="!foldState" class="text-center"><i class="el-icon-d-arrow-right"></i>展开</div>
					<div v-else class="text-center"><i class="el-icon-d-arrow-left"></i>收起</div>
				</div>
			</div>

			<div class="point-card" :style="{ right: detailShow ? '10px' : '-360px' }">
				<DetailCard :info="itemData" :typeOptions="pointTypeOptions" @closeBefore="detailClose" />
			</div>

			<AudioPlayer ref="audioPlayRef" />
		</div>

		<div v-else>
			<MobileList :list="listData" :yearOptions="yearOptions" @checkYear="checkYearMobile" @checkType="changeListTypeMobile" />
		</div>

	</div>
</template>
<script>
	import { getJson } from "@/utils/axios.js"
	import { cityList } from "@/utils/cityList"
	import MapViewer from '@/components/MapViewer.vue';
	import ListCard from "./components/ListCard.vue"
	import DetailCard from "./components/DetailCard.vue"
	import AudioPlayer from '@/components/AudioPlayer.vue';
	import MobileList from "./components/MobileList.vue"
	export default{
		components: { MapViewer, ListCard, DetailCard, AudioPlayer, MobileList },
		data(){
			return{
				traceMode: true,

				viewMode: true, // false 简洁模式 | true 导览模式

				mapTypeActive: '卫星图',
				mapType: [
					{ name: '卫星图', cover: require('@/static/icon/type_1.png') },
					{ name: '矢量图', cover: require('@/static/icon/type_2.png') }
				],

				themeActive: '晴空蓝',
				themeOptions: [ '晴空蓝', '松烟绿', '焰心红'],

				yearOptions: [],
				yearActiveIndex: 1,
				cityOpitons: cityList,
				cityActiveObj: { label: '全国', value: ''},

				pointTypeOptions: [],

				markers: [],
				searchQuery: {},
				listType: 'point',
				listData: [],
				itemData: {},

				foldState: true,
				detailShow: false
			}
		},
		computed: {
			isMobile() {
				return window.innerWidth < 768
			}
		},
		methods: {
			// 数据初始化
			reset(){
				this.detailShow = false
				this.traceMode = true
				this.foldState = true

				this.yearActiveIndex = 1
				this.searchQuery.localDate = this.yearOptions[this.yearActiveIndex].dicValue

				this.cityActiveObj = { label: '全国', value: ''}
				this.searchQuery.cityCode = ''

				this.$refs.mapEditor.setInitView()

				this.getList()
			},
			changeFreeMode(){
				this.foldState = this.traceMode
				this.detailShow = false
				this.$refs.mapEditor.setInitView()
				if(this.traceMode){
					this.getList()
				}else{
					this.listData = []
					this.markers = []
				}
			},
			// 切换图层类型
			changeMapType(item){
				this.mapTypeActive = item.name
			},
			// 切换年份
			checkYear(value){
				this.detailShow = false
				this.$refs.mapEditor.setInitView()
				const index = this.yearOptions.findIndex(item => item.dicValue === value)
				this.yearActiveIndex = index || 0
				this.searchQuery.localDate = value
				this.getList()
			},
			checkYearMobile(value){
				this.searchQuery.localDate = value
				this.getList()
			},
			// 切换地区
			checkCity(value){
				this.cityActiveObj.value = value
				const index = this.cityOpitons.findIndex( item => item.value === value )
				this.cityActiveObj.label = this.cityOpitons[index].label
				this.searchQuery.cityCode = value
				this.getList()
			},
			// 切换列表类型
			changeListType(value){
				this.listType = value
				this.$refs.mapEditor.setInitView()
				this.detailShow = false
				this.getList()
			},
			changeListTypeMobile(value){
				this.listType = value
				this.getList()
			},
			// 查看列表项目
			checkListItem(item){
				if(this.listType === 'line'){
					if(!item.linePoints){
						this.$message('此线路尚未绘制具体信息，请耐心等待');
						return
					}
					this.$refs.audioPlayRef.pause()
					this.$router.push(`/lineDetail?id=${item.id}`)
					return
				}
				const [lat, lng] = item.location
				this.$refs.mapEditor.setMapView(lat, lng)
				this.checkItem(item)
			},
			// 列表展开&收起
			changeFoldState(){
				this.foldState = !this.foldState
			},
			// 查看详情
			checkItem(item){
				if(this.listType === 'line'){
					if(!item.linePoints){
						this.$message('此线路尚未绘制具体信息，请耐心等待');
						return
					}
					this.$refs.audioPlayRef.pause()
					this.$router.push(`/lineDetail?id=${item.id}`)
					return
				}
				const url = this.listType === 'point' ? '/point/detail' : '/line/info'
				getJson(url, { id: item.id }, (res) => {
					const { data } = res
					this.itemData = data || {}
					this.itemData.pictureList = this.itemData.picture ? this.itemData.picture.split(',') : []
					this.itemData.cover = this.itemData.picture ? this.itemData.picture.split(',')[0] : ''
					if(this.listType === 'point'){
						this.itemData.tags = this.itemData.tag ? this.itemData.tag.split(',') :[]
					}else{
						this.itemData.tags = this.itemData.tags ? this.itemData.tags.split(',') :[]
					}
					this.itemData.foodList = this.itemData.foods ? this.itemData.foods.split(',') : []
					this.detailShow = true
				})
			},
			// 关闭详情
			detailClose(){
				this.detailShow = false
			},
			// 获取列表
			getList(){
				if(this.listType === 'point'){
					getJson('/point/list', this.searchQuery, (res) => {
						const { data } = res
						this.listData = data || []
						this.listData.forEach(item => {
							item.pictureList = item.picture ? item.picture.split(',') : []
							item.cover = item.picture ? item.picture.split(',')[0] : ''
							item.location = JSON.parse(item.location)
							item.tags = item.tag ? item.tag.split(',') : []
							item.foodList = item.foods ? item.foods.split(',') : []
						})
						this.markers = this.listData.map(item => {
							return {
								id: item.id,
								name: item.name,
								location: item.location,
							}
						})
					})
				}else{
					getJson('/line/list', this.searchQuery, (res) => {
						const { data } = res
						this.listData = data || []
						this.listData.forEach(item => {
							item.pictureList = item.picture ? item.picture.split(',') : []
							item.cover = item.picture ? item.picture.split(',')[0] : ''
							item.location = JSON.parse(item.location)
							item.tags = item.tags ? item.tags.split(',') :[]
						})
						this.markers = this.listData.map(item => {
							return {
								id: item.id,
								name: item.name,
								location: item.location,
								linePoints: item.linePoints
							}
						})
					})
				}
			},
			// 获取点位类型
			getPointTypeOption(){
				getJson('/dicContent/list', { dicKey: 'walk_point_type' }, (res) => {
					this.pointTypeOptions = res.data || []
				})
			},
			// 获取开放年份
			getOpenYearOption(){
				getJson('/dicContent/list', { dicKey: 'year_list' }, res => {
					const options = res.data || []
					this.yearOptions = [{ dicLabel: '所有年度', divValue: '' }, ...options]
					this.searchQuery.localDate = this.yearOptions[this.yearActiveIndex].dicValue
					this.getList()
				})
			},
		},
		created(){
			this.getPointTypeOption()
			this.getOpenYearOption()
		}
	}
</script>
<style scoped lang="scss">
	:deep(.el-divider--vertical){
		margin: 0 5px;
	}
	.oper-box{
		position: absolute;
		right: 0;top: 10px;
		z-index: 2020;
		background-color: rgba(0, 0, 0, 0.1);
		backdrop-filter: blur(10px);
		padding: 8px 14px;
		border-top-left-radius: 8px;
		border-bottom-left-radius: 8px;
		box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.1);
		display: flex;
		gap: 10px;
		font-size: 15px;
	}
	.type-label{
		transition: 200ms;
		font-size: 15px;
	}
	.type-label:hover{
		color: #1D9EFF!important;
	}
	.maptype{
		border: 2px solid #FFF;
		transition: 200ms;
		.type-name{
			background-color: rgba(0, 0, 0, 0.5);
		}
	}
	.maptype-active{
		border: 2px solid #FF180C!important;
	}
	.maptype:hover{
		border: 2px solid #FFA99A;
	}

	.reset-icon{
		color: #1D9EFF;
		font-weight: 700;
		cursor: pointer;
		transition: 200ms;
	}
	.reset-icon:hover{
		transform: scale(1.1);
	}

	.list-box{
		position: absolute;
		left: 10px;top: 70px;
		z-index: 924;
		width: 320px;
		height: calc( 100% - 120px );
		background-color: rgba(15, 88, 181, 0.3);
		backdrop-filter: blur(8px);
		border-radius: 5px;
		transition: 300ms;
		.fold_btn{
			position: absolute;
			right: -40px;
			top: 50%;
			width: 30px;
			height: 80px;
			margin-top: -40px;
			background-color: #FFF;
			border-radius: 5px;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			cursor: pointer;
			transition: 300ms;
		}
		.fold_btn:hover{
			background-color: rgba(15, 88, 181, 0.8);
			color: #FFF;
		}
	}

	.point-card{
        position: absolute;
        right: 10px;top: 60px;
        transition: 300ms;
        z-index: 2001;
    }
</style>
